/* eslint-disable react/prop-types */
import React from 'react';

import './style.scoped.scss';
import { FaSortAmountDown, FaSortAmountUpAlt } from 'react-icons/fa';

const SortButton = ({
  handleOrder,
  sort,
  small,
}) => {
  if (small) {
    return sort === '<' ? (
      <label className="sort-button sort-button--small" onClick={handleOrder}>
        <FaSortAmountDown />
      </label>
    ) : (
      <label className="sort-button sort-button--small" onClick={handleOrder}>
        <FaSortAmountUpAlt />
      </label>
    );
  } else
    return sort === '<' ? (
      <label className="sort-button" onClick={handleOrder}>
        Z-A <FaSortAmountDown className="ml-2" />
      </label>
    ) : (
      <label className="sort-button" onClick={handleOrder}>
        A-Z <FaSortAmountUpAlt className="ml-2" />
      </label>
    );
};

export default SortButton;
